import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Mr. L***',
  role: '金融高管',
  content: 'SGLonelyGuy 的服务超出了我的预期。伴游不仅外形出众，而且谈吐优雅，非常适合带去商务晚宴。隐私保护也做得非常好。',
  rating: 5
}, {
  id: 2,
  name: 'Mr. C***',
  role: '企业主',
  content: '在新加坡出差期间体验了他们的服务，非常专业。客服响应迅速，安排周到，让我在异国他乡也能感受到温暖。',
  rating: 5
}, {
  id: 3,
  name: 'Mr. W***',
  role: 'IT 精英',
  content: '这是我用过的最靠谱的平台。审核机制让人放心，遇到的每一位伴游都非常真实，没有照骗。强烈推荐金卡会员。',
  rating: 4
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-dark-bg" data-id="element-389">
      <div className="container mx-auto px-4" data-id="element-390">
        <div className="text-center mb-16" data-id="element-391">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-5xl text-white mb-4" data-id="element-392">
            客户评价
          </motion.h2>
          <div className="h-1 bg-gold-500 w-20 mx-auto" data-id="element-393" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-394">
          {testimonials.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card p-8 rounded-lg border border-white/5 relative" data-id="element-395">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gold-500/20" data-id="element-396" />

              <div className="flex gap-1 mb-6" data-id="element-397">
                {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < item.rating ? 'text-gold-500 fill-current' : 'text-gray-600'}`} data-id="element-398" />)}
              </div>

              <p className="text-gray-300 italic mb-6 leading-relaxed" data-id="element-399">
                "{item.content}"
              </p>

              <div className="flex items-center" data-id="element-400">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gold-400 to-gold-700 flex items-center justify-center text-black font-bold text-sm" data-id="element-401">
                  {item.name.charAt(4)}
                </div>
                <div className="ml-3" data-id="element-402">
                  <div className="text-white font-medium" data-id="element-403">{item.name}</div>
                  <div className="text-gray-500 text-xs" data-id="element-404">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}